import React from 'react';
import AsyncSelect from 'react-select/async';
import nationalities from '../../../utilities/nationalities';
import inputProps from '../../../utilities/inputProps';
import PropTypes from 'prop-types';
import {i18nInterface} from '../../../utilities/i18n_common';
import _ from 'lodash';

const selectView = ({countryCode}) => {
  return {value: countryCode, label: i18nInterface(`nationalities.${countryCode}`)};
};

const filteredOptions = (value) => nationalities.filter((nationality) => {
  const matchCountyCode = nationality.countryCode === value.toUpperCase();
  const matchCountryName = nationality.altName.match(
      new RegExp(value, 'i')
  );
  return matchCountyCode || matchCountryName;
}).map(selectView);


const getComparable = _.memoize((val) => _.upperCase(_.deburr(val)));

const loadOptions = (inputValue, callback) => {
  callback(filteredOptions(inputValue).sort((a, b) => {
    const labelA = getComparable(a.label);
    const labelB = getComparable(b.label);
    if (labelA > labelB) {
      return 1;
    }

    if (labelA < labelB) {
      return -1;
    }

    return 0;
  }));
};
class MNationalitySelect extends React.Component {
  render() {
    const {
      visualState,
      error, // eslint-disable-line no-unused-vars
      fieldValue,
      ...other
    } = this.props;

    const isValid = fieldValue && fieldValue.touched && fieldValue.valid;


    return (
      <div className={`m-input m-input-select ${visualState}${isValid ? ' valid' : ''}`}>
        <AsyncSelect
          className='m-input-select__inputfield'
          defaultOptions
          isClearable={false}
          loadOptions={loadOptions}
          {...this.props}
        />
      </div>
    );
  }
}

MNationalitySelect.propTypes = {
  /**
   * id of the input field to link it with a labels htmlFor attribute
   */
  id: PropTypes.string,
  /**
   * value to use the field as controlled input
   * NOTE: it may occure strange behaviour when using it as
   * a controlled component with a mask and parsed values ...
   * Keep it in mind and test what you are doing.
   */
  value: PropTypes.object,
  /**
   * default value, use it, if it is not a controled comp
   */
  defaultValue: PropTypes.object,
  /**
   * placholder value
   */
  placeholder: PropTypes.string,
  /**
   * disable the input field
   */
  disabled: PropTypes.bool,
  /**
   * show the error state
   */
  error: PropTypes.bool,
  /**
   * one or more react elements of type AButton like AButtonIconInput
   * or similar. Displays the actions on the right
   */
  actions: PropTypes.any,
  /**
   * html input type like text, email, ...
   */
  type: PropTypes.string,
  /**
   * optionally display a unit on the right
   */
  unit: PropTypes.string,
  /**
   * fired when the input-field was clicked
   */
  onPress: PropTypes.func,
  /**
   * force a format for the value based on text-mask
   * see more here: https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#mask
   * https://github.com/text-mask/text-mask/tree/master/addons#createnumbermask
   */
  mask: PropTypes.any,

  fieldValue: PropTypes.any,
  /**
   * when the input field changes, passes (event)
   */
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyPress: PropTypes.func,
  visualState: PropTypes.string, // passed by inputProps
  showErrors: PropTypes.any, // passed by inputProps
};
MNationalitySelect.defaultProps = {
  type: 'text',
  error: false,
};

export default inputProps(MNationalitySelect);
